// BL-177 Gate 17e — Action Pill Standard v1.01: only one hover menu open at a time, app-wide.
//
// Think of it as one talking stick: whichever menu opens takes it, and every other open menu is
// told to close on the spot — no grace period, no fade. Every ActionPillMenu and the thread-row
// status icon register here, so a menu built later gets the rule for free by using ActionPillMenu.
//
// A nested menu (a pill that opens a second pill menu to its side) names its parent menu, so
// opening it keeps its own chain of parents open and closes everything else, siblings included.
// Standard: Docs/Build_Execution/Platform/IntelAgent_Action_Pill_Standard_v1_01.md

const openMenus = new Map();

/**
 * Register menu `id` as open and instantly close every other open menu that isn't one of its
 * parents. `close` is called (with no arguments) to make a menu close immediately.
 * Returns an unregister function for when the menu has fully closed or unmounted.
 */
export function claimOpenMenu(id, { parentId = null, close } = {}) {
    const keep = new Set([id]);
    let cursor = parentId;
    while (cursor && !keep.has(cursor)) {
        keep.add(cursor);
        cursor = openMenus.get(cursor)?.parentId ?? null;
    }
    const entry = { parentId, close };
    openMenus.set(id, entry);
    Array.from(openMenus.entries()).forEach(([otherId, other]) => {
        if (keep.has(otherId)) return;
        openMenus.delete(otherId);
        other.close?.();
    });
    return () => {
        if (openMenus.get(id) === entry) openMenus.delete(id);
    };
}

/** Test/debug helper: the ids of every menu currently registered as open. */
export function openMenuIds() {
    return Array.from(openMenus.keys());
}
